// Traduit en francais les libelles injectes en JS par le mini-cart (non couverts par locales/fr.json)
(function () {
  function frenchify(root) {
    if (!root) return;
    root.querySelectorAll('.js-remove-mini-cart').forEach(function (btn) {
      var t = (btn.textContent || '').trim();
      if (t === 'Remove') {
        btn.textContent = 'Retirer';
      }
    });
  }

  function start() {
    var content = document.querySelector('.js-mini-cart-content');
    if (!content) return;
    frenchify(content);
    var observer = new MutationObserver(function () { frenchify(content); });
    observer.observe(content, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
